import API from '../api'
import putUrl from './paths'

export const updateOracleOrder = (orderId) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateOracleOrder, {}, { orderId })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

	export const updateManageSpo = (spo_number) =>
		new Promise((resolve, reject) => {
			API.put(putUrl.updateManageSpo, {}, { spo_number })
				.then((response) => {
					resolve(response)
				})
				.catch((error) => {
					reject(error)
				})
		})
